// extracted by mini-css-extract-plugin
export default {"root":"NestleLanding__root--36N_7","root_mobile":"NestleLanding__root_mobile--Wkjkr"};